module.exports = __webpack_public_path__ + "img/guanyu_shouye@2x.978ca45c.png";